import PropTypes from 'prop-types';

import { Box, Container, Typography, Grid } from '@mui/material';
import { makeStyles, withStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        cursor: 'pointer',
        borderBottom: '1px dashed #e3e3e3',
        padding: '15px 0px',
    },
    title: {
        marginTop: 10,
        maxHeight: 37,
        overflow: 'hidden',
        color: 'black',
        textOverflow: 'ellipses',
    },
    date: {
        textAlign: 'right',
        margin: 10,
        fontSize: 12,
    },
    newsItem: {
        width: '100%',
        backgroundColor: 'white',
        borderRadius: 4,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundSize: 'cover',
        alignItems: 'end',
        // marginTop: 10,
        cursor: 'pointer',
    },
    newsItemCard: {
        // width: '100%',
        backgroundColor: 'white',
        borderRadius: 6,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundImage: 'url(news/news1.jpeg)',
        backgroundSize: 'cover',
        alignItems: 'end',
        marginTop: 10,
        lineHeight: 1.2,
    },
    radTitle: {
        // backgroundColor: 'red',
        // padding: '3px 10px',
        width: 'fit-content',
        // borderRadius: 22,
        color: 'red',
        fontSize: 10,
        // margin: '0px 0px 7px 0px',
    },
    newsTitle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.4,
        maxHeight: 35,
    },
}));

const NewsCard = (props) => {
    const classes = useStyles();

    return (
        <Box className={classes.root} onClick={props.onClick}>
            <Box
                className={classes.newsItem}
                style={{
                    width: 130,
                    // height: props.size === 'lg' ? 418 : 130,
                    // backgroundImage: `url(${props.data.coverImg.url})`,
                    backgroundImage: props.data ? `url(${props.data.image})` : '',
                }}
            ></Box>
            <Box>
                <Box style={{ padding: '0px 0px 0px 15px', width: 170 }}>
                    <Box className={classes.radTitle}>
                        <Typography style={{ fontWeight: 600 }}>{props.data.typeName}</Typography>
                    </Box>
                    <Typography
                        className={classes.newsTitle}
                        style={{ color: 'black' }}
                        variant="subtitle1"
                    >
                        {props.data && props.data.title}
                    </Typography>
                    <Typography
                        style={{ height: 54, overflow: 'hidden' }}
                        dangerouslySetInnerHTML={{ __html: props.data.intro }}
                    ></Typography>
                </Box>
            </Box>
        </Box>
    );
};

NewsCard.defaultProps = {
    title: 'name',
    createAt: '2020/01/01',
};

NewsCard.propTypes = {
    title: PropTypes.string,
    createdAt: PropTypes.string,
};

export default NewsCard;
